import { isContractorContract } from './contracts/contractTypeHelper';
import { isPolishOffice, isPolishOfficeCode } from './officeService';
import { POLAND } from 'framework/form';

type EmployeeContractData = {
  officeId?: string | number | null;
  officeCode?: string | null;
  contractType?: string | null;
  businessRegistrationCountry?: string | null;
};

export const isPolishB2BOrCFSEmployee = (employee?: EmployeeContractData) => {
  if (!employee?.contractType) {
    return false;
  }

  const contractType = String(employee.contractType);
  const isPolishEmployeeById = !!employee?.officeId && isPolishOffice(String(employee.officeId));
  const isPolishEmployeeByCode = !!employee?.officeCode && isPolishOfficeCode(String(employee.officeCode));
  const isPolishByBusinessRegistrationCountry = employee?.businessRegistrationCountry === POLAND.name;

  return (
    (isPolishEmployeeById || isPolishEmployeeByCode || isPolishByBusinessRegistrationCountry) &&
    isContractorContract(contractType)
  );
};
